"use client";

import {
  Textarea as TextArea,
  TextareaProps as TextAreaProps,
} from "@headlessui/react";
import { FC, RefObject } from "react";
import {
  RoundFormField,
  RoundFormFieldProps,
  StandardFormField,
  StandardFormFieldProps,
} from "../FormFieldRendering";

export type BaseTextareaProps = Omit<TextAreaProps, "children"> & {
  ref?: RefObject<HTMLTextAreaElement>;
  children?: never;
};

const BaseTextarea: FC<BaseTextareaProps> = ({ children, ...props }) => {
  return <TextArea {...props} />;
};

export type TextareaProps =
  | ({
      variant: "form";
    } & Omit<StandardFormFieldProps<BaseTextareaProps>, "formControl">)
  | ({
      variant: "round";
    } & Omit<RoundFormFieldProps<BaseTextareaProps>, "formControl">)
  | ({
      variant: "unstyled";
    } & BaseTextareaProps);

export const Textarea: FC<TextareaProps> = ({ variant, ...props }) => {
  switch (variant) {
    case "form":
      return (
        <StandardFormField<HTMLTextAreaElement, BaseTextareaProps>
          formControl={BaseTextarea}
          {...props}
        />
      );
    case "round":
      return <RoundFormField formControl={BaseTextarea} {...props} />;
    case "unstyled":
    default:
      return <BaseTextarea {...props} />;
  }
};
